'use strict';
angular.module('theme', [
	'ngAnimate',
	'ngTouch',
	'ngCookies',
	'ngSanitize',
	'ui.bootstrap',
	'pascalprecht.translate',
	'toastr',
	'angular-md5',
	'theme.templates'
])

// VARS comes in from php
.constant('IS_AUTHENTICATED', window.CUSTOMER ? true : false)
.constant('CUSTOMER', window.CUSTOMER || false)
// Pass WPML language
.constant('LANG', 'sv')

// NG 1.6 introduced es6 constructor compat, but that means that we need to rewrite a lot of our components.
// For now we use the old way...
.config(function($compileProvider) {
	$compileProvider.preAssignBindingsEnabled(true);
})

// Translation config
.config(function ($translateProvider, LANG) {
	$translateProvider.preferredLanguage(LANG).useSanitizeValueStrategy(false);
})

// Toast config
.config(function (toastrConfig) {
	angular.extend(toastrConfig, {
		autoDismiss: true,
		newestOnTop: true,
		preventOpenDuplicates: true,

		// Development vars
		/*
		autoDismiss: false,
		timeOut: 200000
		*/
	});
})

// Set JWT Token if you are logged in
.config(function ($httpProvider) {
	$httpProvider.interceptors.push(function (IS_AUTHENTICATED, CUSTOMER, LANG) {
		return {
			request: function(config) {

				// Only set language and auth for backend requests
				if (_.startsWith(config.url, '/backapi/')) {

					// Pass language to backend
					if (!config.headers['Accept-Language']) {
						config.headers['Accept-Language'] = LANG;
					}

					// If not logged in, continue as usual
					if (!IS_AUTHENTICATED) {
						return config;
					}

					// If we are making a request against the backend, add our JWT Token
					/*
					if (!config.headers.Authorization) {
						config.headers.Authorization = 'Bearer ' + CUSTOMER.token;
					}
					*/

					// If we are making a request against the backend, add our JWT Token
					if (!config.headers['Authorization-Token']) {
						config.headers['Authorization-Token'] = 'Bearer ' + CUSTOMER.token;
					}
				}

				return config;
			}
		};
	});

	// IE has serious problems with caching.
	// By setting the headers below we force all requests to be requested
	//disable IE ajax request caching
	if (!$httpProvider.defaults.headers.get) {
		$httpProvider.defaults.headers.get = {};
	}
	$httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 1 Jan 2000 00:00:00 GMT';
	$httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
	$httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
})

// Scroll to anchor on load
// Since angular overrides the normal anchor functionality, and since we have a fixed header offset
.run(function($rootScope, $location, $anchorScroll) {
	angular.element(document).ready(function () {
		if($location.hash()) {
			$anchorScroll.yOffset = 95;
			$anchorScroll();
		}
	});
});

